import React from "react";
import moment from 'moment';
import {component_tool, utils_tool} from "@/tool";
import { WizTableForm,WizClassifySelect } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, isNotAuth: true } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, isNotAuth: true } })
let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'examRecord';
let {
  WizRow,
  WizCol,
} = component_tool;
import { Table, Input, Button, Popconfirm, Form, Upload, message } from 'antd';

let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const configPerson = (data) => {
  const {examId,questionId} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "任职",
      name: "userIdentityInfo",
      tableItem: {
        width: 300,
      },
    },
    {
      title: "答题次数",
      name: "answerTimeCount",
      tableItem: {
        width: 100,
      },
    },
    
    {
      title: "答错次数",
      name: "answerErrorTimeCount",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "答错率",
      name: "answerErrorRate",
      tableItem: {
      },
    },
   
    
  ]
};

const templateConfigPerson = (data) => {
  const {} = data;
  console.log("data==",data);
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: configPerson(data),
        btnAccessCheck:false,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['export'],
          buttons: [
            
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "exportPerson",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters, examId: data.examId ,questionId:data.questionId}
                }
              }
            },
          ]
        },
       
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['errorQuestionAnalysis'],
        rowOperateView: [
          {
            key: "errorQuestionAnalysis",
            custom: true,
            params: { children: "错误答案" },
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "comment" + new Date().getTime(),
                modalParams: {
                  title: "错误答案详情",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    let errorAnswerInfos = e.record.errorAnswerInfos
                    errorAnswerInfos && errorAnswerInfos.forEach(d => {
                      if (!d.answer || d.answer.length == 0) {
                        d.answer = '未作答'
                      } 
                    })
                    const columns = [
                      {
                        title: '错误答案',
                        dataIndex: 'answer',
                      },
                      {
                        title: '错误次数',
                        dataIndex: 'errorTime',
                      },
                    ];
                    return (
                      <Table columns={columns} dataSource={errorAnswerInfos} size="middle" pagination={false}/>
                    );
                  },
                  footer: null,
                  width: 600,
                },
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              },
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {examId,questionId} = data;
  return {
    list: {
      path: `${componentName}/getErrorQuestionPersonInfoAnalysisPage`,
      payload: {
        key: `${componentName}@getErrorQuestionPersonInfoAnalysisPage`,
        apiParams: {pageNum: 1, pageSize: 10,examId,questionId}
      }
    },
    exportPerson: {
      path: `${componentName}/getErrorQuestionPersonInfoAnalysisExport`,
      payload: {
        key: `${componentName}@getErrorQuestionPersonInfoAnalysisExport`,
        apiParams: {examId,questionId}
      }
    },
  }
};


let reduxTemplateConfigPerson = (args) => {
  const {examId,questionId} = args;
  return {
    apis: apis({examId,questionId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfigPerson, templateConfigPerson};
